import { Navigate, Outlet, Route, Routes } from 'react-router-dom';

import { AdminPage } from '@/features/admin/routes/AdminPage.js';
import { LoginPage } from '@/features/auth/routes/LoginPage.js';
import { useAuthStore } from '@/features/auth/store/authStore.js';
import { CollectionDetailPage } from '@/features/collections/routes/CollectionDetailPage.js';
import { DiscoverPage } from '@/features/discover/routes/DiscoverPage.js';
import { HomePage } from '@/features/home/routes/HomePage.js';
import { ImportPage } from '@/features/import/routes/ImportPage.js';
import { LibraryPage } from '@/features/library/routes/LibraryPage.js';
import { ProfilePage } from '@/features/profile/routes/ProfilePage.js';
import { UpcomingPage } from '@/features/upcoming/routes/UpcomingPage.js';

import { AppShell } from './layout/AppShell.js';

export function AppRouter(): JSX.Element {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      {/* Inscription publique désactivée — toute tentative redirige vers le login. */}
      <Route path="/register" element={<Navigate to="/login" replace />} />
      <Route element={<RequireAuthShell />}>
        <Route path="/" element={<HomePage />} />
        <Route path="/library" element={<LibraryPage />} />
        <Route path="/import" element={<ImportPage />} />
        <Route path="/discover" element={<DiscoverPage />} />
        <Route path="/upcoming" element={<UpcomingPage />} />
        <Route path="/collections/:id" element={<CollectionDetailPage />} />
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/admin" element={<AdminPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function RequireAuthShell(): JSX.Element {
  const isAuthenticated = useAuthStore((s) => Boolean(s.accessToken));
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  return (
    <AppShell>
      <Outlet />
    </AppShell>
  );
}
